const ROOT_KEYS = {
    AUTH: '',
    GENERAL: '',
    PANEL: '/admin',
    USER: '/user',
} as const;

// ----------------------------------------------------------------------

export const PATHS = {
    // ---------------- AUTH ----------------
    AUTH: {
        LOGIN: `${ROOT_KEYS.AUTH}/login`,
        NEW_PASSWORD: `${ROOT_KEYS.AUTH}/login/forgot-password/set-new-password`,
        FORGOT_PASSWORD: `${ROOT_KEYS.AUTH}/login/forgot-password`,
        FORGOT_PASSWORD_CONFIRM: `${ROOT_KEYS.AUTH}/login/forgot-password/confirm`,
        SIGNUP: `${ROOT_KEYS.AUTH}/signup`,
        SIGNUP_FORM: `${ROOT_KEYS.AUTH}/signup/form`,
        SIGNUP_CONFIRM: `${ROOT_KEYS.AUTH}/signup/confirm`,
        SIGNUP_PHONE: `${ROOT_KEYS.AUTH}/signup/phone-number`,
        SIGNUP_NEW_PASSWORD: `${ROOT_KEYS.AUTH}/signup/set-new-password`,
        SIGNUP_STORE_TYPE: `${ROOT_KEYS.AUTH}/signup/select-store-type`,
        RESET_PASSWORD: `${ROOT_KEYS.AUTH}/reset-password`,
    },

    // ---------------- GENERAL ----------------
    GENERAL: {
        HOME: `${ROOT_KEYS.GENERAL}/`,
        ABOUT: `${ROOT_KEYS.GENERAL}/about`,
        FAQ: `${ROOT_KEYS.GENERAL}/faq`,
        ISACO: `${ROOT_KEYS.GENERAL}/isaco`,
        NEWS: `${ROOT_KEYS.GENERAL}/news`,
        PAYMENT: `${ROOT_KEYS.GENERAL}/payment`,
        PRODUCT: (id: string | number, slug: string) => `${ROOT_KEYS.GENERAL}/product/${id}/${slug}`,
        PRODUCTS: `${ROOT_KEYS.GENERAL}/products`,
        SOFTWARE: `${ROOT_KEYS.GENERAL}/software`,
        SUPPORT: `${ROOT_KEYS.GENERAL}/support`,
        TERMS_OF_SALE: `${ROOT_KEYS.GENERAL}/terms-of-sale`,
    },

    // ---------------- PANEL (Admin Dashboard) ----------------
    PANEL: {
        ROOT: `${ROOT_KEYS.PANEL}`,
        HOME: `${ROOT_KEYS.PANEL}/home`,
        PAYMENTS: `${ROOT_KEYS.PANEL}/payments`,
        COMMENTS: `${ROOT_KEYS.PANEL}/comments`,

        ORDERS: {
            ROOT: `${ROOT_KEYS.PANEL}/orders`,
            DETAILS: (id: string | number) => `${ROOT_KEYS.PANEL}/orders/${id}`,
        },

        USERS: {
            ROOT: `${ROOT_KEYS.PANEL}/users`,
            DETAILS: (id: string | number) => `${ROOT_KEYS.PANEL}/users/${id}`,
        },

        ConsolidatedFinance: {
            ROOT: `${ROOT_KEYS.PANEL}/consolidated-finance`,
        },

        FACTOR_CHECKS: {
            ROOT: `${ROOT_KEYS.PANEL}/factor-checks`,
            DETAILS: (id: string | number) => `${ROOT_KEYS.PANEL}/factor-checks/${id}`,
        },

        INVENTORY_COUNTING: {
            ROOT: `${ROOT_KEYS.PANEL}/inventory-counts`,
            DETAILS: (id: string | number) => `${ROOT_KEYS.PANEL}/inventory-counts/${id}`,
        },
    },

    // ---------------- USER (User Dashboard) ----------------
    USER: {
        ROOT: `${ROOT_KEYS.USER}`,
        EDIT_PROFILE: `${ROOT_KEYS.USER}/edit-profile`,
        EDIT_STORE_TYPE: `${ROOT_KEYS.USER}/edit-store-type`,
        CART: `${ROOT_KEYS.USER}/cart`,
        COMMENTS: `${ROOT_KEYS.USER}/comments`,

        ORDERS: {
            ROOT: `${ROOT_KEYS.USER}/orders`,
            DETAILS: (id: string | number) => `${ROOT_KEYS.USER}/orders/${id}`,
        },

        FINANCE: {
            ROOT: `${ROOT_KEYS.USER}/finance`,
            DETAILS: (id: string | number) => `${ROOT_KEYS.USER}/finance/${id}`,
        },

        FACTORS: {
            ROOT: `${ROOT_KEYS.USER}/factors`,
            DETAILS: (id: string | number) => `${ROOT_KEYS.USER}/factors/${id}`,
        },

        MESSENGER: {
            ROOT: `${ROOT_KEYS.USER}/messenger`,
            DOCKED: (chatId: string | number) => `/docked-messenger/${chatId}`,
            CHAT: (chatId: string | number) => `${ROOT_KEYS.USER}/messenger/${chatId}`,
        },
    },

    // ---------------- ERRORS ----------------
    ERRORS: {
        PAGE_403: '/403',
        PAGE_404: '/404',
        PAGE_500: '/500',
    },
} as const;

